<template>
<div class="chapter">
<div class="inner_page">
<p class="calibre_7" id="filepos4001"><span class="calibre9">First Sentient Publications edition 2006<br class="calibre1"/>Copyright © 2006 by David Parrish</span></p>
<p class="calibre_8"><span class="calibre9">All rights reserved. This book, or parts thereof, may not be reproduced in any form without permission, except in the case of brief quotations embodied in critical articles and reviews.</span></p>
<p class="calibre_8"><span class="calibre9">A paperback original</span></p>
<p class="calibre_8"><span class="calibre9">Cover design by Kim Johansen, Black Dog Design<br class="calibre1"/>Book design by Nicholas Cummings</span></p>
<hr class="calibre10"/>
<p class="calibre_6"><span class="calibre9"><span class="bold">Library of Congress Cataloging-in-Publication Data</span></span></p>
<p class="calibre_8"><span class="calibre9">Parrish, David, MD.</span></p>
<p class="calibre_9"><span class="calibre9">Nothing I see means anything : quantum questions, quantum answers / David Parrish.— 1st Sentient Publications ed.</span></p>
<blockquote class="calibre_10"><p class="calibre_11"><span class="calibre9">p. cm.</span></p></blockquote>
<p class="calibre_11"><span class="calibre9">ISBN 978-1-5918-1138-4</span></p>
<p class="calibre_11"><span class="calibre9">1. Consciousness. 2. Quantum theory. 3. Mysticism. I. Title.</span></p>
<p class="calibre_8"><span class="calibre9">BF311.P31368 2005<br class="calibre1"/>150—dc22</span></p>
<blockquote class="calibre_10"><p class="calibre_12"><span class="calibre9">2005029685</span></p></blockquote>
<p class="calibre_8"><span class="calibre9">10 9 8 7 6 5 4 3 2</span></p>
<p class="calibre_2"><span class="calibre6">SENTIENT PUBLICATIONS</span></p>
<p class="calibre_6"><span class="calibre9">A Limited Liability Company<br class="calibre1"/>1113 Spruce Street<br class="calibre1"/>Boulder, CO 80302<br class="calibre1"/><a href="http://www.sentientpublications.com" target="_blank">www.sentientpublications.com</a></span></p> <div class="mbp_pagebreak" id="calibre_pb_2"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_002.vue?2439a333